import React from 'react';
import actions from "../../store/actions"
import { connect } from "react-redux";
import { ActivityService,PublicActivityService } from '../../api/api'

import { Pagination, Modal, Button } from 'antd'
import moment from 'moment'
import { FormattedMessage } from 'react-intl'
import VlecImg from '../../component/VlecImg'
import NoData from '../../component/NoData'
import { formatHTMLMessage } from 'react-intl-universal';
class PublicActivities extends React.Component {
    state = {
        visible: false,
        PageIndex: 1,
        PageSize: 8,
        TotalItemCount: 0,
        DataList: []

    };
    GetList() {
        PublicActivityService.GetList(
            {
                PageIndex: this.state.PageIndex,
                PageSize: this.state.PageSize,
            }
        ).then((result) => {
            if (result.DataResult) {
                this.setState({

                    PageIndex: result.DataResult.CurrentPageIndex,
                    PageSize: result.DataResult.PageSize,
                    TotalItemCount: result.DataResult.TotalItemCount,
                    DataList: result.DataResult.DataList
                });
            }

        });
    }
    componentDidMount = () => {

        this.GetList();
    }
    componentDidUpdate() {

    }
    PageChange(page) {
        console.log(page,'pagepage')
        this.setState({

            PageIndex: page,

        }, () => {
            this.GetList();
            document.body.scrollTo(300, 350);

        });



        //window.scrollTo(300, 350);

    }
    Goto(id) {

        this.props.history.push("/ActivityDetail/" + id);
    }

    render() {
        return (
            <section>
                <Modal
                    title=""
                    visible={this.state.visible && this.props.local !== 'en'}
                    maskClosable={false}
                    closable={false}
                    footer={null}
                >
                    <div className="actModalTxt">由于疫情原因，未来中心公众活动将推迟举办，活动信息敬请等待后续通知。</div>
                    <div style={{ textAlign: "center" }}                    >
                        <Button type="primary" htmlType="submit" className="tjxxBtn" onClick={() => {
                            this.props.history.push("/Home");
                        }}>
                            我知道了
                        </Button>
                    </div>
                </Modal>
                <div className="activities_con">
                    <div className="indexDiv ">
                        <div className="center home_Acitivites">
                            <div className="titleH4">
                                <h4>Create Possibilities</h4>
                                <p><FormattedMessage id="intl-event-title1" /><br />
                                    <FormattedMessage id="intl-event-title2" /><br />
                                    <FormattedMessage id="intl-event-title3" /><br />
                                </p>


                            </div>
                        </div>
                    </div>
                    {this.props.local !== 'en' && this.state.DataList && this.state.DataList.length > 0 ? <div>
                        <ul className="indexAcitivites">
                            {this.state.DataList.map((item, i) => (

                                <li key={i}>
                                    <div className="iA_con">
                                        <div className="iA_con_img">
                                            <a href="javascript:void(0)" onClick={this.Goto.bind(this, item.ID)}>
                                                <VlecImg type="api" src={item.Thumbnail} alt="" />
                                            </a>
                                        </div>
                                        <h4> <a href="javascript:void(0)" onClick={this.Goto.bind(this, item.ID)}>{item.Title}</a></h4>
                                        <p>
                                            <span className="iA_Title">{moment(item.StartTime).format('YYYY.MM.DD hh:mm')} &nbsp;&nbsp;</span>
                                            {/* <span> <FormattedMessage id="upper-limit" />:{item.SignUpPeopleNumberTop}</span> */}
                                            {/* <span>{item.Place}</span> */}
                                        </p>
                                        {/* <p>
                                            <a href="javascript:void(0)" onClick={this.Goto.bind(this, item.ID)}>
                                                {item.ActivityContentText} </a>
                                        </p> */}
                                    </div>
                                    <p className="hoverP">
                                        <span><img src="../../images/qrcode_for.jpg" alt="" /></span>
                                        <span>扫一扫关注“联想未来中心”公众号，<br></br>输入“主题活动”报名活动</span>
                                    </p>
                                </li>
                            ))}

                        </ul>
                        <div className="paging">
                            <Pagination
                                current={this.state.PageIndex}
                                onChange={this.PageChange.bind(this)}
                                pageSize={this.state.PageSize}
                                total={this.state.TotalItemCount}
                            />
                        </div></div> : <div className="nonedate_img"><img src="images/nonedate.png" /></div>}
                </div>
            </section>
        )
    }
}
export default connect(state => ({ ...state.Language }), { ...actions.Language })(PublicActivities)


// WEBPACK FOOTER //
// ./src/containers/PublicActivities/index.js